import {FieldValidationRules} from '../types';

export const restrictedSicCodesCI = [
  '1799',
  '2819',
  '2892',
  '2899',
  '5812',
  '5813',
  '5999',
  '7299',
  '7389',
  '7941',
  '7999',
  '8611',
  '8621',
  '8631',
  '8641',
  '8651',
  '8661',
  '8699',
  '8999',
  '9224',
  '9229',
  '9999',
];

const CIValidationConstantRules: Record<string, FieldValidationRules> = {
  'EligibleLivesAndParticipation.numberOfEligibleLives': {
    required: true,
    min: 3,
    max: 499,
    errorMessages: {
      required: "'Number of lives' is required",
      minMax: "'Number of lives' should be between 3 and 499",
    },
  },
  'CIBenefitStructureIndividual.benefitAmount': {
    required: true,
    allowedValues: [10000, 15000, 20000, 30000],
    errorMessages: {
      allowedValues: "'Benefit Amount' is mandatory",
      // allowedValues: `Acceptable Amount: ${[10000, 15000, 20000, 30000]
      //   .map(val => `  $${val.toLocaleString(navigator.language, {minimumFractionDigits: 0})}`)
      //   .toString()}`,
    },
  },
  'CICoverageRating.rateStructureCd': {
    required: true,
    errorMessages: {
      required: "'Rate Structure' is mandatory",
    },
  },
  'CICoverageRating.rateFormatCd': {
    required: true,
    errorMessages: {
      required: "'Rate Format' is mandatory",
    },
  },
  'CIFundingStructure.payrollFrequency': {
    required: true,
    errorMessages: {
      required: "'Payroll Frequency' is mandatory",
    },
  },
  'CISkinCancerRider.benefitAmount': {
    required: true,
    min: 100,
    max: 500000,
    step: 1,
    errorMessages: {
      required: "'Benefit Amount' is mandatory",
      minMax: `The value must be between $100 and $500000 with step 1`,
    },
  },
  'CIChildhoodConditions.childhoodConditionsPct': {
    required: true,
    min: 0,
    max: 200,
    step: 5,
    errorMessages: {
      required: "'Childhood Conditions' is mandatory",
      minMax: `The value must be between 0% and 200% with step 5`,
    },
  },
  'CIChildhoodConditions.neonatalICUPct': {
    required: true,
    min: 0,
    max: 200,
    step: 5,
    errorMessages: {
      required: "'Neonatal Intensive Care Unit' is mandatory",
      minMax: `The value must be between 0% and 200% with step 5`,
    },
  },
  'CISpecConditionAndInfDiseaseBenefit.planBnfAmountPct': {
    required: true,
    min: 0,
    max: 200,
    step: 5,
    errorMessages: {
      required: "'Plan Benefit Amount' is mandatory",
      minMax: `The value must be between 0% and 200% with step 5`,
    },
  },
};

export const CIValidationRules = (validationVal?: {attributeName: string; amount: number}) => {
  const valiadtionRules: Record<string, FieldValidationRules> = validationVal
    ? {
        ...CIValidationConstantRules,
        [`CICoveredConditions.${validationVal.attributeName}`]: {
          required: true,
          min: 0,
          max: validationVal.amount,
          step: 5,
          errorMessages: {
            required: 'The value is mandatory',
            minMax: `The value must be between 0% and ${validationVal.amount}% with step 5%`,
          },
        },
      }
    : CIValidationConstantRules;
  return valiadtionRules;
};
